import { Dispatch, SetStateAction } from 'react'
import {
	Price,
	ProductImage,
	ProductInfo,
	ProductTag,
	ProductTagWrapper,
	SkuCode,
	Wrapper,
} from './PlpProductCard.style'

import { Product } from '../../../types/products'
import { useTranslation } from 'react-i18next'

type Props = {
	product: Product
	setSelectedUpc: Dispatch<SetStateAction<string | null>>
}

const PlpProductCard: React.FC<Props> = ({ product, setSelectedUpc }) => {
	const { t } = useTranslation()

	const {
		UPC,
		skuCode,
		imageUrl,
		priceWholesale,
		priceSuggested,
		currency,
		tags,
	} = product

	return (
		<Wrapper onClick={() => setSelectedUpc(UPC)}>
			<ProductInfo>
				<SkuCode>{skuCode}</SkuCode>
				<div>
					<Price className="bolder">
						{priceWholesale && parseFloat(priceWholesale) !== 0
							? `${currency} ${priceWholesale}`
							: null}
					</Price>
					<Price>
						{priceSuggested && parseFloat(priceSuggested) !== 0
							? `${t('currency.SRP')} ${priceSuggested}`
							: null}
					</Price>
				</div>
			</ProductInfo>

			<ProductImage>
				{imageUrl ? (
					<img src={imageUrl + '?imwidth=300'} alt="product" />
				) : null}
			</ProductImage>

			<ProductTagWrapper>
				{!!tags.length ? (
					tags.map((tag, index) => <ProductTag key={index}>{tag}</ProductTag>)
				) : (
					<ProductTag className="placeholder" />
				)}
			</ProductTagWrapper>
		</Wrapper>
	)
}

export default PlpProductCard
